'use strict';

$('a[href^="/account/logout"]').on("click", function() {
    $.ajax( $(this).attr('href') )
      .done(function() {
        // Here you will change the url to whatever page you want to redirect to
        window.location.href = "/account";
      });
    return false;
  });

var countryBtns = document.querySelectorAll('.nav__country-toggle-btn')

var domain = window.location.host;
var newDomain;

var country = document.documentElement.dataset.country;

var ipCountry;

fetch('https://extreme-ip-lookup.com/json/')
.then( res => res.json())
.then(response => {
    ipCountry = response.countryCode;
     console.log(response)
 })
 .catch((data, status) => {

 })

 if(ipCountry == 'CA'){
     ipCountry = 'canada';
 } else if(ipCountry == 'US'){
     ipCountry = 'usa';
 } else{
     ipCountry = null;
 }



 console.log(ipCountry && ipCountry != country)

 if(ipCountry && ipCountry != country){
     //if the country doesn't match, show the banner
     document.querySelectorAll('.js-ip-conflict')[0].classList.add('show')
 }

if (country == 'canada') {
    // newDomain = 'https://accounts.crownverity.com';
    newDomain = 'https://shop.crownverity.com/account';
    document.querySelectorAll('.js-country-can').forEach(function(button){
        button.classList.add('js-current-country')
    })
} else if(country == 'usa') {
    // newDomain = 'https://accounts.crownverity.ca';
    newDomain = 'https://shop.crownveritycanada.ca/account';
    document.querySelectorAll('.js-country-usa').forEach(function(button){
        button.classList.add('js-current-country')
    })
}

countryBtns.forEach(function(btn) {

    btn.addEventListener('focus', function() {
      // this.parentElement.classList.add('open')
      this.closest('.nav__country-toggle').classList.add('open')

    })

    btn.addEventListener('click', function(e) {
        e.preventDefault();

        if(this.classList.contains('js-current-country')){
            this.closest('.nav__country-toggle').classList.toggle('open')
        } else{
            window.location.href = newDomain;
        }

    })

    // var subMenu = btn.nextElementSibling
    // var subMenuLinks = subMenu.querySelectorAll('a')
    var lastBtnIndex = countryBtns.length - 1
    var lastBtn = countryBtns[lastBtnIndex]

    lastBtn.addEventListener('blur', function() {
      // btn.parentElement.classList.remove('focus')
      btn.closest('.nav__country-toggle').classList.remove('open')
    })

    countryBtns[0].addEventListener('blur', function() {
      // btn.parentElement.classList.remove('focus')
      btn.closest('.nav__country-toggle').classList.remove('open')
    })

})


var footerCountryBtns = document.querySelectorAll('.footer__country-toggle-btn')

footerCountryBtns.forEach(btn => {

    btn.addEventListener('focus', function() {
      // this.parentElement.classList.add('open')
      this.closest('.footer__country-toggle').classList.add('open')

    })

    btn.addEventListener('click', function(e) {
        e.preventDefault();

        if(this.classList.contains('js-current-country')){
            this.closest('.footer__country-toggle').classList.toggle('open')
        } else{
            window.location.href = newDomain;
        }

    })

    // var subMenu = btn.nextElementSibling
    // var subMenuLinks = subMenu.querySelectorAll('a')
    var lastBtnIndex = footerCountryBtns.length - 1
    var lastBtn = footerCountryBtns[lastBtnIndex]

    lastBtn.addEventListener('blur', function() {
      // btn.parentElement.classList.remove('focus')
      btn.closest('.footer__country-toggle').classList.remove('open')
    })

    countryBtns[0].addEventListener('blur', function() {
      // btn.parentElement.classList.remove('focus')
      btn.closest('.footer__country-toggle').classList.remove('open')
    })

})
